import { render } from "./TheSettingsBar.vue?vue&type=template&id=aadac088&scoped=true"
const script = {}

import "./TheSettingsBar.vue?vue&type=style&index=0&id=aadac088&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aadac088"]])

export default __exports__